import React from 'react';

export const cvUrl = "https://form.run/@pre-cookon"

export const logoUrl = "https://firebasestorage.googleapis.com/v0/b/soct-lp.appspot.com/o/cookon%2Flogo.svg?alt=media&token=3dc436b6-65aa-471c-872b-5af3e5fa186f";

export const firstView = {
  mainImg:"https://firebasestorage.googleapis.com/v0/b/soct-lp.appspot.com/o/cookon%2Fmain.jpeg?alt=media&token=e66b8e45-db6f-4cb4-99a9-042386e2cbda",
  mainTitle:<>あなただけの料理教室を<br/>オンラインでひらこう</>,
  bodyText:<>Cookon（クックオン）なら、カンタン操作で動画レッスンを販売できます<br/>
             新しい生徒さんとの出会いや、継続的な接点作りをいますぐに</>
}

export const titles = {
  features:{
    title:"ABOUT US",
    subTitle:"サービスの特徴"
  },
  steps:{
    title:"STEPS",
    subTitle:"利用のながれ"
  }
}

export const features = [
      {
          title:`動画販売機能`,
          description:<>アップロードするだけで<br/>すぐに動画販売開始</>,
          icon:"movie_filter"
      },
      {
          title:`セミナー販売機能`,
          description:<>オンラインセミナーも<br/>販売することが可能</>,
          icon:"speaker_phone"
      },
      {   
          title:"月額会員機能",
          description:<>安定した会員制度で<br/>顧客基盤を構築できます</>,
          icon:"fireplace",
      }
  ];
export const steps = [
      {
          title:`まずは無料登録`,
          subheader:"基本利用料金は無料",
          description:<>まずは気軽に無料プランから全ての機能をご利用いただけます。</>,
          src:"https://firebasestorage.googleapis.com/v0/b/soct-lp.appspot.com/o/cookon%2Fstep1.jpg?alt=media&token=e577754e-0b5d-4645-bdcd-2eca7663a735"
      },
      {
          title:`動画をアップロード`,
          subheader:"いつでもレッスン動画を公開可能",
          description:<>撮影した動画をアップロードするだけで、スマートフォンからでも公開可能です。</>,
          src:"https://firebasestorage.googleapis.com/v0/b/soct-lp.appspot.com/o/cookon%2Fstep2.jpeg?alt=media&token=0903232f-8459-46c3-8abf-f53dce44785c"
      },
      {
          title:`販売価格の設定`,
          subheader:"自由に価格を設定できます",
          description:<>無料動画から高額コンテンツまで、目的に合わせて自由に設定できます。</>,
          src:"https://firebasestorage.googleapis.com/v0/b/soct-lp.appspot.com/o/cookon%2Fstep3.jpeg?alt=media&token=0c69d0ef-ff46-4862-b997-8a0a7845e6b5"
      },
  ];
export const faqs = [
      {
          question:"動画以外のコンテンツについても、販売することは可能でしょうか？",
          answer:"はい、可能です。セミナーや教材などの販売にも対応しております。"
      },
      {
          question:"利用料金は発生しますか？",
          answer:"基本機能は全て無料で利用することができます。特定の追加機能を利用する場合には別途月額費用を頂く場合がございます。"
      },
      {
          question:"販売手数料についておしえてください",
          answer:"決済、およびシステム手数料として販売金額の20%を頂戴しております。サービス運営のほか、購入者の集客に利用させていただきます。"
      },
      {
          question:"登録後のキャンセル・中途解約は可能ですか？",
          answer:"プラン変更、解約はいつでも実施可能です。利用料支払いが完了した利用料の払い戻しはできませんので、ご注意ください。"
      },
  ];

export const ctaText = "いますぐ先行申し込み";

export const links = [
      {
          text:"運営会社",
          href:"/company"
      },
      {
          text:"特定商法取引法に基づく表記",
          href:"/tokusho"
      },
      {
          text:"プライバシーポリシー",
          href:"/privacy"
      },
  ];
export const copyRights = "© Curip inc.";

export const companyInfo = [
  {
    title:"会社名",
    value:"Curip株式会社"
  },
  {
    title:"設立年月日",
    value:"2020年8月19日"
  },
  {
    title:"本社",
    value:"東京都 千代田区 九段南 1丁目 5番 6号 りそな九段ビル 5F"
  },
  {
    title:"主な事業内容",
    value:"アプリケーションの企画・開発、各種コンサルティング"
  },
]

export const tokushoInfo = [
  {
    title:"事業者",
    value:"Curip株式会社"
  },
  {
    title:"代表者",
    value:"舟瀬基"
  },
  {
    title:"所在地",
    value:"東京都 千代田区 九段南 1丁目 5番 6号 りそな九段ビル 5F"
  },
  {
    title:"サービス利用料金",
    value:"利用者は無料で基本機能を利用することができます。特定の追加機能を利用する場合、表示された月額利用料を支払う必要があります"
  },
  {
    title:"支払い方法・支払い時期",
    value:"クレジットカードにて、プラン選択時にお支払い頂く必要がございます"
  },
  {
    title:"サービスの提供時期",
    value:"登録時から、退会手続きが完了するまでご利用いただけます"
  },
  {
    title:"キャンセル・免責事項",
    value:"プラン確定後のキャンセルはお受けできません。変更、解約は翌月から適用されます。"
  },
  {
    title:"お問い合わせ先",
    value:"お問い合わせフォームからご連絡ください。上記に掲げるもの以外の特定商取引に関する法律第11条に基づき表示が要求される事項は、問合せフォームからご連絡いただければ、遅滞なく提供します。"
  },
]

export const privacyInfo = `
Curip株式会社（以下「当社」といいます。）は、「Cookon」の名称で提供・運営する、WEBサービス（以下「本サービス」といいます。また、本サービス上でコンテンツ販売を行う者と購入する者を、それぞれ「販売者」、「購入者」といいます。）における販売者から取得する情報（以下「販売者情報」といい、販売者以外でコンテンツの対象となる者の情報を含みます。）を、以下のとおり取り扱います。

#### 1. 適用範囲
本プライバシーポリシーは本サービスに適用されます。  
なお、「他社モジュールの設置」等に記載される他事業者等による受講者情報の収集は、本プライバシーポリシーの適用範囲ではございません。

#### 2. 取得する受講者情報及び利用方法
本サービスにおいて当社が取得及び利用する販売者情報は、以下のとおりです。  
情報のご提供は販売者の任意ですが、ご提供いただけない場合、本サービスの全部又は一部を利用できない場合があります。  
2.1 ご提供いただく情報  
販売者が本サービスをご利用いただくにあたり、以下の情報の提供をお願いする場合があります。  
(1) サービスの申込みに関する情報  
サービスの申込みにあたり、説明会案内および講義の参加案内のため、氏名、連絡先、生年月日の情報をご提供いただきます。  
(2) 問合せ時に取得する情報  
当社に問い合わせいただいた際、電話番号、メールアドレス、端末機種名、OS情報等を取得する場合があります。これらの情報は問合せに対する調査、返答、本人確認等のために利用します。  
2.2 サービス利用情報  
販売者が本サービスをご利用いただくにあたり、以下の情報を取得する場合があります。  
(1) サービス利用状況に関する情報  
統計データの作成及びより良いサービス提供のために、受講者による本サービスの利用状況に関する情報を取得して利用する場合があります。  
(2) 機器情報  
販売者が利用する機器情報（OS、端末の個体識別情報、Browser ID、言語設定等）を取得する場合があります。  
(3) クッキー（Cookie）  
Cookieを利用し、当社が販売者に付与した内部識別子に紐付ける場合があります。当社は、これらの情報はより良いサービス提供のため、またご本人確認や正常なサービス提供を妨害する不正行為防止のために利用します。また、本サービスではGoogle Analyticsを利用する場合がございます。 お客様はCookieの使用可否を選択できますが、Cookieの保存を拒む場合にはログインが必要なサービス等、本サービスの一部をご利用いただけない場合がございます。  

#### 3. 販売者情報の利用目的
当社は、取得した販売者情報を以下の目的で利用します。  
（1）当社のサービスの提供・改善・開発のため  
• 販売者が当社のサービスを円滑に利用できるようにするため  
• 当社のサービスの利用に関する統計データを作成するため  
• 販売者からの問合せに対応するため  
• 現在提供している当社のサービス又は今後提供を検討している当社のサービスに関するアンケートを実施するため  
• 当社が本サービス上で提供するコンテンツを作成するため  
• 今後の当社のサービスに関する新企画立案を行い、これを提供するため  
• キャンペーン等の抽選及び賞品や商品発送のため  
• 商品購入時や有料サービス利用時等における請求処理のため  
• その他本サービスに関する重要なお知らせその他必要に応じた連絡を行うため  
（2） 当社のサービスのセキュリティ又は不正利用防止のため  
• スパム行為や不正アクセスその他不正利用防止のため  
• 不正利用が発生した場合などに本人確認や連絡を行うため  
（3） パーソナライズ又は広告配信のため  
• 当社及び当社グループ（当社の子会社または関連会社をいい、定義は「財務諸表等の用語、様式及び作成方法に関する規則」に従い、外国にある子会社、関連会社も含まれます。以下同様とします。）のサービスに関する情報等又は当社以外の事業者が広告主となる広告情報等を告知するため
• 販売者個人にカスタマイズされた当社のサービスを提供するため  

#### 4. 販売者情報の委託
当社は、利用目的の達成に必要な範囲内で、販売者情報の全部又は一部を業務委託先（外国にある委託先を含みます。）に委託する場合があります。その際、業務委託先としての適格性を十分審査するとともに、契約にあたって守秘義務に関する事項等を規定し、情報が適正に管理される体制作りを行います。

#### 5. 販売者情報の第三者提供

当社は、以下の場合を除いて、販売者の同意なく販売者情報を第三者に提供することはありません。
(1) 販売者本人が事前に同意した場合
(2) 法令に基づく場合
(3) 人の生命、身体又は財産の保護のために必要がある場合であって、本人の同意を得ることが困難である場合
(4) 公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき
(5) 国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき
(6) 合併、会社分割、営業譲渡その他の事由によって医師の個人情報の提供を含む当社の事業の承継が行われる場合

#### 6. 販売者情報の共同利用

当社は、次に掲げるとおり、当社グループ（当社の子会社または関連会社をいい、定義は「財務諸表等の用語、様式及び作成方法に関する規則」に従い、外国にある子会社、関連会社も含まれます。以下同様とします。）との間で、以下の利用目的の範囲内で、受講者情報（要配慮個人情報にあたるものを除きます。）を共同利用いたします。なお、受講者情報の管理についての責任は、当社が有します。

(1) 当社グループにおけるサービスの提供・改善・開発のため
(2) 当社グループにおける不正利用防止のため
(3) 当社グループにおけるパーソナライズ又は広告配信のため

#### 7. 販売者の権利

7.1 利用目的の通知及び開示の請求について

販売者は、当社に対し、次の場合を除き、当社が別途定めた手続に従って、利用目的の通知及び個人情報の開示を請求することができます。
• 開示することで本人又は第三者の生命、身体、財産その他の権利利益を害するおそれがある場合
• 開示することで当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合
• 開示することが法令に違反することとなる場合
• 開示の請求がご本人からであることが確認できない場合
なお、個人情報の開示の請求にあたっては、当社が別途定めた手続に従って開示手数料を頂くことがあります。

7.2 訂正・追加・削除の請求について
販売者は、当社が別途定めた手続に従って、個人情報の訂正・追加・削除を請求することができます。この場合、当社は、利用目的の達成に必要な範囲内で遅滞なく調査を行い、その結果に基づき当該個人情報の訂正・追加・削除を行います。
7.3 利用停止及び第三者提供の停止の請求について
販売者は、当社が別途定めた手続に従って、個人情報の利用停止及び第三者提供の停止を請求することができます。この場合、当社は、個人情報の保護に関する法律に従って適切に対応いたします。

#### 8. 退会者の情報
本サービスから退会された場合、販売者情報は関連法規及び社内規定に従って適切に処理いたします。

#### 9. お子様の情報
15歳未満のお客様が本サービスを利用し、販売者情報を入力される場合には保護者の方の同意のもとに行っていただけますようお願いいたします。

#### 10. 他社モジュールの設置
当社は、今後、他社媒体に掲載した本サービスの広告の費用を広告代理店に支払う目的で広告掲載効果を測定するため、又は利用状況の分析等のために他社モジュールを設置する場合があります。

#### 11. 本プライバシーポリシーの改定
本プライバシーポリシーは改定される場合があります。重要な変更にあたってはお客様に対して分かりやすい方法にて改定内容を告知します。

#### 12. 問合せ
本プライバシーポリシーに関して不明な点がある場合及び本サービスにおける販売者情報の取扱いに関する質問・苦情・相談等がある場合は、お問い合わせフォームよりご連絡ください。

2020年10月25日制定
`
